import { combineReducers } from 'redux-immutable';
import pause from './pause';
import music from './music';
import matrix from './matrix';
import next from './next';
import cur from './cur';
import startLines from './startLines';
import max from './max';
import points from './points';
import speedStart from './speedStart';
import speedRun from './speedRun';
import lock from './lock';
import clearLines from './clearLines';
import combo from './combo';
import reset from './reset';
import drop from './drop';
import keyboard from './keyboard';
import focus from './focus';


const rootReducer = combineReducers({
  pause,
  music,
  matrix,
  next,
  cur,
  startLines,
  max,
  points,
  speedStart,
  speedRun,
  lock,
  clearLines,
  combo,
  reset,
  drop,
  keyboard,
  focus,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js